import React, { useState, useEffect } from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import LoginModal from "./LoginModal";
import loadable from "@react-loadable/revised";
import { userIsLoggedIn } from "@clarion/foundation/dist/Utils/userUtils";
import { getQueryStringParameters } from "@clarion/foundation/dist/Utils/serialiseUtils";
import { toggleLoginModal } from "@clarion/foundation/dist/Settings/actions/globalActions";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck";
import { userDataApiCall } from "@clarion/foundation/dist/Utils/apiUtils";
import "@clarion/foundation/dist/Theming/styles/forms.css";
import "@clarion/foundation/dist/Theming/styles/account.css";
const LoadableMigrationModal = loadable({
  loader: () => import("./MigrationModal/index"),
  loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
const Login = ({
  fields,
  sitecoreContext,
  t,
  rendering
}) => {
  const dispatch = useDispatch();
  const isLoggedIn = userIsLoggedIn(sitecoreContext);
  const [openMigrationModal, setOpenMigrationModal] = useState(false);
  const loader = useSelector(state => state.loader);
  const federatedLinkServiceCall = () => {
    userDataApiCall("/api/federated-link/generate-token", rendering).then(response => {
      if (response.Success) {
        window.location.href = response.RedirectUrl || "/";
      }
    }).catch(() => {});
  };
  useEffect(() => {
    const queryParameters = getQueryStringParameters(window.location.search);
    const shouldOpenLoginModal = queryParameters.openLogin === "true";
    const redirectUrl = queryParameters.redirectUrl;
    if (queryParameters.federatedLink === "true") {
      if (isLoggedIn) {
        federatedLinkServiceCall();
        return;
      }
      window.sessionStorage.setItem("federatedLink", true);
      dispatch(toggleLoginModal(true));
      return;
    }
    if (!isLoggedIn && shouldOpenLoginModal) {
      dispatch(toggleLoginModal(true));
    }
    if (isLoggedIn && shouldOpenLoginModal && redirectUrl) {
      if (!/^(?:[a-z+]+:)?\/\//i.test(redirectUrl)) {
        window.location.href = redirectUrl;
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoginModal, {
    setOpenMigrationModal: setOpenMigrationModal,
    fields: fields,
    sitecoreContext: sitecoreContext,
    t: t,
    rendering: rendering
  }), loader.loadRegisterModals && /*#__PURE__*/React.createElement(LoadableMigrationModal, {
    openMigrationModal: openMigrationModal,
    setOpenMigrationModal: setOpenMigrationModal,
    fields: fields,
    sitecoreContext: sitecoreContext,
    t: t
  }));
};
const LoginWithFieldsCheck = withFieldsCheck(Login);
const LoginWithFieldsCheckAndTranslation = withTranslation()(LoginWithFieldsCheck);
export default withSitecoreContext()(LoginWithFieldsCheckAndTranslation);